<template>
  <div style="height: 400px" ref="gantt"></div>
</template>

<script>
import "dhtmlx-gantt";

export default {
  name: "gantt",
  props: {
    tasks: {
      type: Object,
      default() {
        return { data: [], links: [] };
      }
    }
  },

  mounted: function() {
    gantt.config.fit_tasks = true;
    gantt.config.readonly = true;

    gantt.attachEvent("onTaskSelected", id => {
      let task = gantt.getTask(id);
      this.$emit("task-selected", task);
    });

    gantt.config.scale_unit = "month";
    gantt.config.date_scale = "%F, %Y";

    //default columns definition
    gantt.config.columns = [
      { name: "text", label: "Travaux", width: "*", tree: true },
      { name: "start_date", label: "Date initiale", align: "center" },
      { name: "duration", label: "Durée", align: "center" }
    ];

    //langue
    gantt.locale = {
      date: {
        month_full: [
          "Janvier",
          "Février",
          "Mars",
          "Avril",
          "Mai",
          "Juin",
          "Juillet",
          "Août",
          "Septembre",
          "Octobre",
          "Novembre",
          "Décembre"
        ],
        month_short: [
          "Jan",
          "Fév",
          "Mar",
          "Avr",
          "Mai",
          "Juin",
          "Juil",
          "Aôu",
          "Sep",
          "Oct",
          "Nov",
          "Déc"
        ],
        day_full: [
          "Dimanche",
          "Lundi",
          "Mardi",
          "Mercredi",
          "Jeudi",
          "Vendredi",
          "Samedi"
        ],
        day_short: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"]
      },
      labels: {
        new_task: "Tâche neuve",
        icon_save: "Enregistrer",
        icon_cancel: "Annuler",
        icon_details: "Détails",
        icon_edit: "Modifier",
        icon_delete: "Effacer",
        confirm_closing: "", //Vos modifications seront perdus, êtes-vous sûr ?
        confirm_deleting: "L'événement sera effacé sans appel, êtes-vous sûr ?",

        section_description: "Description",
        section_time: "Période",
        section_type: "Type",

        /* grid columns */

        column_text: "Tâche neuve",
        column_start_date: "Date initiale",
        column_duration: "Durée",
        column_add: "",

        /* link confirmation */

        confirm_link_deleting: "seront supprimées",
        link_start: "(début)",
        link_end: "(fin)",

        type_task: "Task",
        type_project: "Project",
        type_milestone: "Milestone",

        minutes: "Minutes",
        hours: "Heures",
        days: "Jours",
        weeks: "Semaine",
        months: "Mois",
        years: "Années"
      }
    };

    gantt.init(this.$refs.gantt);
    gantt.clearAll();
    gantt.parse(this.$props.tasks);
  }
};
</script>

<style scoped>
/*@import "~dhtmlx-gantt/codebase/dhtmlxgantt.css";*/
@import "~dhtmlx-gantt/codebase/dhtmlxgantt.css";
</style>



// WEBPACK FOOTER //
// src/components/calendrier/Gantt.vue